import { cadOpType } from "lib/operations/factory";
import { EditDataCommand } from "./edit-base";

export class CircleEditDataCommand extends EditDataCommand {
    protected opType = cadOpType.EDITCIRCLE;

}